export default __webpack_public_path__ + "images/0x3082cc23568ea640225c2467653db90e9250aaa0.png";